<template>
  <el-col :span="span">
    <el-row :gutter="gutter" class="c-app-board-section">
      <template v-for="(item, index) in innerBoardItems" :key="'board-item' + index">
        <CAppBoardItem :span="itemSpan" :height="itemHeight" :config="item" />
      </template>
    </el-row>
  </el-col>
</template>

<script setup lang="ts">
import { _, ref, computed, inject, onMounted, useHostAppInstance } from '@zto/zpage'
import type { AppBoardItem } from './types'

import { APP_BOARD_STATE_KEY } from './consts'
import { calcBoardItemAttrs } from './util'

const props = withDefaults(
  defineProps<{
    span?: number
    gutter?: number
    itemSpan?: number
    itemHeight?: number | string
    items?: AppBoardItem[] | Function
  }>(),
  {
    gutter: 10
  }
)

const boardState = inject(APP_BOARD_STATE_KEY)

const app = useHostAppInstance()

const CAppBoardItem = app.resolveComponent('CAppBoardItem')

// 处理过的boardItems
const innerBoardItems = computed<any>(() => {
  const context = app.useContext(boardState)

  let boardItems: AppBoardItem[] = []

  if (_.isFunction(props.items)) {
    boardItems = (props.items as any)(context)
  } else {
    boardItems = props.items || []
  }

  return boardItems
})
</script>

<style lang="scss" scoped>
.c-app-board-section {
}
</style>
